import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Table, Tabs, UploadFile } from 'antd';
import { dateCommon, validateMessages } from '../../helpers/common';
import { DeleteOutlined, EditOutlined, PlusOutlined, SaveOutlined, EyeOutlined, UploadOutlined, PaperClipOutlined } from '@ant-design/icons';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from 'react';
import { luuNguoiPhuThuoc, xoaNguoiPhuThuoc, luuTaiLieuNguoiPhuThuoc, xoaTaiLieuNguoiPhuThuoc } from '../../services/nhanvien';
import { toast } from 'react-toastify';
import ModalTextForm from '@app/components/modal/ModalTextForm';
import dayjs from 'dayjs';
import { NguoiPhuThuoc } from '../../models/nhanvien/NguoiPhuThuoc';
import { convertDataSelectBox, layDanhMucQuanHeNguoiPhuThuoc } from '../../services/danhmuc';
import { DataSelectBox } from '../../models/selectbox';
import { TaiLieu } from '../../models/nhanvien/TaiLieu';
import { urlAdmin } from '../../constants';
import Dropzone from 'react-dropzone';

const BLOCKED_EXTENSIONS = ['.exe', '.bat', '.cmd', '.sh', '.msi', '.ps1', '.vbs', '.com', '.scr', '.pif'];

const NguoiPhuThuocBox = ({ listData, idNhanVien, isThemMoi, onSubmit, listTaiLieu }: { listData?: Array<NguoiPhuThuoc>; idNhanVien?: number; isThemMoi?: boolean; onSubmit: () => void; listTaiLieu?: Array<TaiLieu>; }) => {
    var dataSource = (listData || []).map((item: any, index) => { item.key = index; return item; });

    const [optionsQuanHe, setOptionQuanHe] = useState<Array<DataSelectBox>>([]);
    const [selectedNPT, setSelectedNPL] = useState<NguoiPhuThuoc | null>(null);
    const [loading, setLoading] = useState(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [idXoa, setIdXoa] = useState<number>(0);
    const [form] = Form.useForm();

    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [loadingFile, setLoadingFile] = useState(false);
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [pendingFiles, setPendingFiles] = useState<File[]>([]);
    const [idTaiLieuXoa, setIdTaiLieuXoa] = useState<number>(0);

    const setFormDetailModal = (value: NguoiPhuThuoc | null) => {
        form.setFieldsValue({
            "id": value?.id,
            "idNhanVien": idNhanVien,
            "thangBatDau": value?.thangBatDau ? dayjs(dateCommon.formatDate(value?.thangBatDau), "DD/MM/YYYY") : null,
            "thangKetThuc": value?.thangKetThuc ? dayjs(dateCommon.formatDate(value?.thangKetThuc), "DD/MM/YYYY") : null,
            "hoTenNguoiPhuThuoc": value?.hoTenNguoiPhuThuoc || "",
            "mstNguoiPhuThuoc": value?.mstNguoiPhuThuoc || "",
            "idQuanHePhuThuoc": value?.idQuanHePhuThuoc || null,
            "ngaySinhNguoiPhuThuoc": value?.ngaySinhNguoiPhuThuoc ? dayjs(dateCommon.formatDate(value?.ngaySinhNguoiPhuThuoc), "DD/MM/YYYY") : null,
        });
        setShowModalChiTiet(true);
    }

    const loadDataSelectBox = async () => {
        try {
            setLoading(true);
            var rs = await layDanhMucQuanHeNguoiPhuThuoc();
            setOptionQuanHe(convertDataSelectBox(rs));
            setLoading(false);
        }
        catch (err: any) {
            setLoading(false);
        }
    }

    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            values.ngaySinhNguoiPhuThuoc = values.ngaySinhNguoiPhuThuoc.endOf("day");
            await luuNguoiPhuThuoc(values);
            setShowModalChiTiet(false);
            toast.success('Lưu thông tin người phụ thuộc thành công!')
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        setLoading(false);
        onSubmit();
    };

    const onDelete = async () => {
        try {
            setLoading(true);
            await xoaNguoiPhuThuoc(idXoa);
            toast.success('Xoá thông tin người phụ thuộc thành công!');
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setLoading(false);
        onSubmit();
    };

    const handleDrop = (acceptedFiles: File[]) => {
        const valid = acceptedFiles.filter(f => {
            const ext = '.' + f.name.split('.').pop()?.toLowerCase();
            if (BLOCKED_EXTENSIONS.includes(ext)) {
                toast.warning(`File "${f.name}" không được phép upload.`);
                return false;
            }
            if (f.size > 20000000) {
                toast.warning(`File "${f.name}" vượt quá 20MB.`);
                return false;
            }
            return true;
        });
        setPendingFiles(prev => [...prev, ...valid]);
    };

    const handleUploadFiles = async () => {
        if (pendingFiles.length === 0) return;
        try {
            setLoadingFile(true);
            const uploadList: UploadFile[] = pendingFiles.map((f, i) => ({
                uid: `new-${Date.now()}-${i}`,
                name: f.name,
                originFileObj: f as any,
            }));
            await luuTaiLieuNguoiPhuThuoc(pendingFiles, idNhanVien ?? 0);
            toast.success('Lưu file đính kèm thành công!');
            setPendingFiles([]);
            setShowModalUpload(false);
            onSubmit();
        } catch (err: any) {
            toast.error('Đã xảy ra lỗi, lưu file không thành công!');
        }
        setLoadingFile(false);
    };

    const handleXoaTaiLieu = async () => {
        try {
            await xoaTaiLieuNguoiPhuThuoc(idTaiLieuXoa);
            toast.success('Xoá file đính kèm thành công!');
            setIdTaiLieuXoa(0);
            onSubmit();
        } catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá file không thành công!');
            setIdTaiLieuXoa(0);
        }
    };

    useEffect(() => {
        loadDataSelectBox();
    }, []);

    useEffect(() => {
        var fileHienTai: UploadFile[] = (listTaiLieu || []).map((item: TaiLieu) => ({
            uid: item.idTaiLieu + "tailieu",
            name: item.tenTep,
            status: 'done',
            url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
        }));
        setFileList(fileHienTai);
    }, [listTaiLieu]);

    return (
        <div className="card-outline">
            {idXoa > 0 && <ModalTextForm show={idXoa > 0}
                title="Xoá thông tin người phụ thuộc"
                handleClose={() => setIdXoa(0)}
                handleSave={onDelete}>
                Xác nhận xóa thông tin người phụ thuộc đang chọn
            </ModalTextForm>}

            {idTaiLieuXoa > 0 && (
                <ModalTextForm
                    show={idTaiLieuXoa > 0}
                    title="Xoá file đính kèm"
                    handleClose={() => setIdTaiLieuXoa(0)}
                    handleSave={handleXoaTaiLieu}
                >
                    Xác nhận xóa file đính kèm đang chọn?
                </ModalTextForm>
            )}

            {showModalUpload && (
                <ModalTextForm
                    show={showModalUpload}
                    title="Thêm file đính kèm"
                    handleClose={() => { setShowModalUpload(false); setPendingFiles([]); }}
                    handleSave={handleUploadFiles}
                >
                    <Dropzone onDrop={handleDrop} multiple={true}>
                        {({ getRootProps, getInputProps, isDragActive }) => (
                            <div {...getRootProps()} className="hrm-dropzone-uploadfile">
                                <input {...getInputProps()} />
                                {isDragActive ? (
                                    <p>Kéo và thả tệp tin ở đây...</p>
                                ) : pendingFiles.length > 0 ? (
                                    <div>
                                        {pendingFiles.map((f, i) => (
                                            <p key={i}><PaperClipOutlined rev="" /> {f.name} ({(f.size / 1024).toFixed(1)} KB)</p>
                                        ))}
                                        <p style={{ color: '#888', marginTop: 8 }}>Kéo thả để thêm file khác</p>
                                    </div>
                                ) : (
                                    <p>Kéo và thả hoặc nhấn để chọn file tài liệu (tối đa 20MB/file)</p>
                                )}
                            </div>
                        )}
                    </Dropzone>
                </ModalTextForm>
            )}

            {showModalChiTiet && <ModalTextForm title="Quản lý thông tin người phụ thuộc"
                hideFooter
                show={showModalChiTiet}
                handleClose={() => setShowModalChiTiet(false)}
            >
                {isThemMoi ?
                    <Form
                        layout="vertical"
                        validateMessages={validateMessages}
                        onFinish={onFinish}
                        form={form}
                    >
                        <Form.Item hidden name="id"><Input /></Form.Item>
                        <Form.Item hidden name="idNhanVien"><Input /></Form.Item>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Họ tên người phụ thuộc"
                                    name="hoTenNguoiPhuThuoc"
                                    rules={[{ required: true }]} >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Ngày sinh"
                                    name="ngaySinhNguoiPhuThuoc"
                                    rules={[{ required: true }]} >
                                    <DatePicker style={{ width: "100%" }}
                                        changeOnBlur={true}
                                        placeholder="Chọn ngày"
                                        format={"DD/MM/YYYY"}
                                        disabledDate={(current: any) => {
                                            const now = dayjs();
                                            return current && current > now;
                                        }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Mã số thuế người phụ thuộc"
                                    name="mstNguoiPhuThuoc"
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Quan hệ với người nộp thuế"
                                    name="idQuanHePhuThuoc"
                                    rules={[{ required: true }]} >
                                    <Select
                                        notFoundContent={<div>Không có dữ liệu</div>}
                                        options={optionsQuanHe}
                                        loading={loading}
                                        placeholder="Chọn quan hệ"
                                        showSearch
                                        filterOption={function (search, item: any) {
                                            return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                                        }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Bắt đầu giảm trừ từ"
                                    name="thangBatDau"
                                    rules={[{ required: true }]}
                                >
                                    <DatePicker changeOnBlur={true} picker="month" style={{ width: "100%" }} placeholder="Chọn tháng" format={["MM/YYYY", "MMYYYY"]} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Đến tháng"
                                    name="thangKetThuc"
                                >
                                    <DatePicker changeOnBlur={true} picker="month" style={{ width: "100%" }} placeholder="Chọn tháng" format={["MM/YYYY", "MMYYYY"]} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.Item>
                            <Button type="primary" className="float-right" htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                                Lưu
                            </Button>
                        </Form.Item>
                    </Form> :
                    <>
                        <Form.Item hidden name="id"><Input /></Form.Item>
                        <Form.Item hidden name="idNhanVien"><Input /></Form.Item>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Họ tên người phụ thuộc</div>
                                    <label>{selectedNPT?.hoTenNguoiPhuThuoc}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Ngày sinh</div>
                                    <label>{selectedNPT?.ngaySinhNguoiPhuThuoc != null ? dateCommon.formatDate(selectedNPT?.ngaySinhNguoiPhuThuoc) : ""}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Mã số thuế người phụ thuộc</div>
                                    <label>{selectedNPT?.mstNguoiPhuThuoc}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Quan hệ với người nộp thuế</div>
                                    <label>{selectedNPT?.tenQuanHe}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Bắt đầu giảm trừ từ</div>
                                    <label>{selectedNPT?.thangBatDau != null ? dateCommon.formatDate(selectedNPT?.thangBatDau) : ""}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Đến tháng</div>
                                    <label>{selectedNPT?.thangKetThuc != null ? dateCommon.formatDate(selectedNPT?.thangKetThuc) : ""}</label>
                                </div>
                            </Col>
                        </Row>
                    </>
                }
            </ModalTextForm>}
            <Tabs tabBarExtraContent={isThemMoi ?
                <Button
                    className="hrm-btn hrm-btn-warning"
                    onClick={() => {
                        setFormDetailModal(null);
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
                : null} defaultActiveKey="1" items={[
                    {
                        key: '1',
                        label: 'Danh sách người phụ thuộc',
                        children:
                            <div className="card">
                                <Row gutter={16} style={{ marginBottom: 12 }}>
                                    <Col span={24}>
                                        <div style={{ display: 'flex', flexDirection: "column",  alignItems: 'flex-start', gap: 8, padding: '10px 0 0 10px' }}>
                                            {isThemMoi && (
                                                <Button
                                                    icon={<UploadOutlined rev="" />}
                                                    onClick={() => { setPendingFiles([]); setShowModalUpload(true); }}
                                                    loading={loadingFile}
                                                >
                                                    Thêm file đính kèm
                                                </Button>
                                            )}
                                            {fileList.map(f => (
                                                <span key={f.uid} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                                    <PaperClipOutlined rev="" />
                                                    <a href={f.url} target="_blank" rel="noreferrer">{f.name}</a>
                                                    {isThemMoi && (
                                                        <DeleteOutlined
                                                            rev=""
                                                            style={{ color: 'red', cursor: 'pointer' }}
                                                            onClick={() => {
                                                                const id = parseInt(f.uid.split("tailieu")[0]);
                                                                setIdTaiLieuXoa(id);
                                                            }}
                                                        />
                                                    )}
                                                </span>
                                            ))}
                                        </div>
                                    </Col>
                                </Row>
                                <Table
                                    locale={{ emptyText: "Không có dữ liệu" }}
                                    dataSource={dataSource}
                                    pagination={false}
                                    rowClassName={(record, index) => {
                                        return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                    }}
                                >
                                    <Column
                                        title="STT"
                                        key="STT"
                                        render={(value, record, index) =>
                                        (
                                            <>
                                                {index + 1}
                                            </>
                                        )
                                        }
                                    />
                                    <Column
                                        title="Họ tên người phụ thuộc"
                                        key="hoTenNguoiPhuThuoc"
                                        dataIndex="hoTenNguoiPhuThuoc"
                                    />
                                    <Column
                                        title="Ngày sinh người phụ thuộc"
                                        key="ngaySinhNguoiPhuThuoc"
                                        render={(value: NguoiPhuThuoc, record, index) =>
                                        (
                                            <>
                                                {dateCommon.formatDate(value?.ngaySinhNguoiPhuThuoc)}
                                            </>
                                        )
                                        }
                                    />
                                    <Column title="Mã số thuế người phụ thuộc" dataIndex="mstNguoiPhuThuoc" key="mstNguoiPhuThuoc" />
                                    <Column title="Quan hệ với người nộp thuế" dataIndex="tenQuanHe" key="tenQuanHe" />
                                    <Column
                                        title="Thời gian giảm trừ từ"
                                        key="thangBatDau"
                                        render={(value: NguoiPhuThuoc, record, index) =>
                                        (
                                            <>
                                                {dateCommon.formatDate(value?.thangBatDau, "MM/yyyy")}
                                            </>
                                        )
                                        } />
                                    <Column
                                        title="Thời gian giảm trừ đến"
                                        key="thangKetThuc"
                                        render={(value: NguoiPhuThuoc, record, index) =>
                                        (
                                            <>
                                                {dateCommon.formatDate(value?.thangKetThuc, "MM/yyyy")}
                                            </>
                                        )
                                        } />
                                    {isThemMoi ?
                                        <Column width="10%" title="" key="action"
                                            render={(value: NguoiPhuThuoc, record, index) =>
                                            (
                                                <Space>
                                                    <Button type="primary" size={"small"} loading={loading} title="Sửa"
                                                        icon=<EditOutlined rev="" />
                                                        onClick={() => { setFormDetailModal(value); }}
                                                    >
                                                        Sửa
                                                    </Button>
                                                    <Button type="primary" danger size={"small"} loading={loading} title="Xóa"
                                                        onClick={() => { setIdXoa(value.id) }}
                                                        icon=<DeleteOutlined rev="" />
                                                    >
                                                        Xóa
                                                    </Button>
                                                </Space>
                                            )
                                            }
                                        /> :
                                        <Column width="10%" title="" key="action"
                                            render={(value: NguoiPhuThuoc, record, index) =>
                                            (
                                                <Space>
                                                    <Button type="primary" size={"small"} loading={loading} title="Xem"
                                                        icon=<EyeOutlined rev="" />
                                                        onClick={() => { setFormDetailModal(value); setSelectedNPL(value) }}
                                                    >
                                                        Xem
                                                    </Button>
                                                </Space>
                                            )
                                            }
                                        />
                                    }
                                </Table>
                            </div>
                    },
                ]}>
            </Tabs>
        </div>
    );
};

export default NguoiPhuThuocBox;